import { AppState, Auth0Provider } from '@auth0/auth0-react'
import { FC } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { config } from '../../../../config'
import { SearchParameters } from '../../../../constants/searchParameter'

const { AUTH0_AUDIENCE, AUTH0_CLIENT_ID, AUTH0_DOMAIN } = config

const AuthProvider: FC = ({ children }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const queryParam = new URLSearchParams(location.search)
  const authConnection = queryParam.get(SearchParameters.AUTH_CONNECTION)

  const onRedirectCallback = (appState: AppState) => {
    navigate(appState?.returnTo || window.location.pathname)
  }

  return (
    <Auth0Provider
      audience={AUTH0_AUDIENCE}
      cacheLocation="localstorage"
      clientId={AUTH0_CLIENT_ID}
      domain={AUTH0_DOMAIN}
      connection={authConnection ?? undefined}
      authorizationParams={{
        ...(authConnection ? { connection: authConnection } : {}),
      }}
      onRedirectCallback={onRedirectCallback}
      redirectUri={window.location.origin}
      useRefreshTokens={false}
    >
      {children}
    </Auth0Provider>
  )
}

export { AuthProvider }
